module.exports = __webpack_public_path__ + "img/logo-32.fc87d493.png";